import {createReducer} from '../utility'




export const events = createReducer({},{
    "FETCH_EVENTS_SUCCESSFUL"(state, {data}){
        if(data){
            return {
                ...state,
                event: data
            }
        }else{
            return{
                ...state
            }
        }
    } 
})